export default __webpack_public_path__ + "static/media/background_kingdom_with_fire.75694949.jpg";